var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "100px" },
          attrs: {
            title: _vm.title,
            width: 700,
            visible: _vm.visible,
            confirmLoading: _vm.confirmLoading,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "取消",
            okText: "保存",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.confirmLoading } },
            [
              _c(
                "a-form",
                { attrs: { form: _vm.form } },
                [
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "车牌号",
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: [
                                      "plateNumber",
                                      _vm.validatorRules.plateNumber,
                                    ],
                                    expression:
                                      "['plateNumber', validatorRules.plateNumber]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { placeholder: "请输入车牌号" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "品牌",
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: ["brand", _vm.validatorRules.brand],
                                    expression:
                                      "['brand', validatorRules.brand]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { placeholder: "请输入品牌" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "型号",
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: ["model", _vm.validatorRules.model],
                                    expression:
                                      "['model', validatorRules.model]",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { placeholder: "请输入型号" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "颜色",
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator.trim",
                                    value: ["color"],
                                    expression: "['color']",
                                    modifiers: { trim: true },
                                  },
                                ],
                                attrs: { placeholder: "请输入颜色" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "车辆类型",
                              },
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: ["vehicleType"],
                                      expression: "['vehicleType']",
                                    },
                                  ],
                                  attrs: { placeholder: "请选择车辆类型" },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "sedan" } },
                                    [_vm._v("轿车")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "suv" } },
                                    [_vm._v("SUV")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "truck" } },
                                    [_vm._v("货车")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "bus" } },
                                    [_vm._v("客车")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "other" } },
                                    [_vm._v("其他")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "状态",
                              },
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: [
                                        "status",
                                        _vm.validatorRules.status,
                                      ],
                                      expression:
                                        "['status', validatorRules.status]",
                                    },
                                  ],
                                  attrs: { placeholder: "请选择状态" },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "idle" } },
                                    [_vm._v("空闲")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "using" } },
                                    [_vm._v("使用中")]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { attrs: { value: "repair" } },
                                    [_vm._v("维修")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                label: "备注",
                              },
                            },
                            [
                              _c("a-textarea", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: ["remark"],
                                    expression: "['remark']",
                                  },
                                ],
                                attrs: { placeholder: "请输入备注", rows: 3 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }